import { render, staticRenderFns } from "./Pagamento.vue?vue&type=template&id=2ab90845&scoped=true&"
import script from "./Pagamento.vue?vue&type=script&lang=js&"
export * from "./Pagamento.vue?vue&type=script&lang=js&"
import style0 from "./Pagamento.vue?vue&type=style&index=0&id=2ab90845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab90845",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab90845')) {
      api.createRecord('2ab90845', component.options)
    } else {
      api.reload('2ab90845', component.options)
    }
    module.hot.accept("./Pagamento.vue?vue&type=template&id=2ab90845&scoped=true&", function () {
      api.rerender('2ab90845', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/Pagamento.vue"
export default component.exports